import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type {
  IApiGetVideoResponseBody,
  IApiGetVideosRequestBody,
  IApiGetVideosResponseBody,
} from './VideosApi.types';

export class VideosApi {
  public constructor(private client: ApiClient) {}

  public async get(
    appId: string | undefined,
    videoId: string,
  ): Promise<IApiGetVideoResponseBody> {
    const request: IApiJsonRequest = {
      path: `/media/video/${videoId}`,
      method: 'get',
    };

    const response = await this.client.fetchJson<IApiGetVideoResponseBody>(
      request,
      { appId },
    );

    return response.body;
  }

  public async getAll(
    appId: string,
    body: IApiGetVideosRequestBody,
  ): Promise<IApiGetVideosResponseBody> {
    const request: IApiJsonRequest = {
      path: '/videos',
      method: 'get',
      params: body,
    };

    const response = await this.client.fetchJson<IApiGetVideosResponseBody>(
      request,
      {
        appId,
      },
    );

    return response.body;
  }
}
